






import Vue from 'vue';
import { mapState } from 'vuex';
import { AppScope } from '../../../constants/appScope';
import { HotelInterface } from '../../../types/hotelInterface';

export default Vue.extend({
  name: 'PrivacyPolicy',
  computed: {
    ...mapState({
      hotel(state: any): HotelInterface {
        return this.isDashboard ? state.dashboard.hotel : state.landing.hotel.item;
      },
    }),
    isDashboard(): boolean {
      const scope = this.getScope();
      return scope === AppScope.Dashboard;
    },
    hotelPrivacyPolicy() {
      if (!this.hotel.privacy_policy) {
        return '';
      }
      return this.hotel.privacy_policy[this.i18nTag()]
        ? this.hotel.privacy_policy[this.i18nTag()]
        : this.hotel.privacy_policy.en;
    },
  },
});
